import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AppUsersService } from './api/appUsers.service';
import { AppsService } from './api/apps.service';
import { AuthService } from './api/auth.service';
import { CompaniesService } from './api/companies.service';
import { CronService } from './api/cron.service';
import { ProgramsService } from './api/programs.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AppUsersService,
    AppsService,
    AuthService,
    CompaniesService,
    CronService,
    ProgramsService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<any> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
